import { combineReducers } from 'redux';
import { canvas, STATE_KEY as CANVAS_STATE_KEY } from './canvas';
import { imageChange, STATE_KEY as IMAGE_CHANGING_STATE_KEY } from './imageChange';
import { isLoading, STATE_KEY as IS_LOADING_STATE_KEY } from './preview';
import { bookProperties, STATE_KEY as BOOK_PROPERTIES_STATE_KEY } from './bookProperties';
import { allowRender, STATE_KEY as ALLOW_RENDER } from './allowRender';
import { setAutoFill, STATE_KEY as SET_AUTO_FILL } from './setAutoFill';
import { addPageToViewed, STATE_KEY as ADD_PAGE_TO_VIEWED } from './addPageToViewed';
import { previewFinished, STATE_KEY as PREVIEW_STATE_KEY } from '../ui/previewFinished';
import { isOrder, STATE_KEY as ORDER_STATE_KEY } from '../ui/isOrder';
import { isSavedBook, STATE_KEY as IS_SAVED_BOOK_STATE_KEY } from '../ui/isSavedBook';
import { loadCoverDependOnBgType, STATE_KEY as LOAD_FIRST_COVER_TO_BACKGROUND_TYPE_STATE_KEY } from '../ui/loadFirstCoverToBackgroundType';
import { babyPageProperties, STATE_KEY as BABY_PAGE_PROPERTIES } from './babyPage';
import { backgroundImageSelected, STATE_KEY as BACKGROUND_IMAGE_SELECTED } from '../ui/backgroundImageSelected.js';
import { dateImageSelected, STATE_KEY as DATE_IMAGE_SELECTED } from '../ui/dateImageSelected.js';

const editorUI = combineReducers({
  [CANVAS_STATE_KEY]: canvas,
  [IMAGE_CHANGING_STATE_KEY]: imageChange,
  [IS_LOADING_STATE_KEY]: isLoading,
  [BOOK_PROPERTIES_STATE_KEY]: bookProperties,
  [ALLOW_RENDER]: allowRender,
  [SET_AUTO_FILL]: setAutoFill,
  [ADD_PAGE_TO_VIEWED]: addPageToViewed,
  [PREVIEW_STATE_KEY]: previewFinished,
  [ORDER_STATE_KEY]: isOrder,
  [IS_SAVED_BOOK_STATE_KEY]: isSavedBook,
  [LOAD_FIRST_COVER_TO_BACKGROUND_TYPE_STATE_KEY]: loadCoverDependOnBgType,
  [BABY_PAGE_PROPERTIES]: babyPageProperties,
  [BACKGROUND_IMAGE_SELECTED]: backgroundImageSelected,
  [DATE_IMAGE_SELECTED]: dateImageSelected,
});

export default editorUI;



// WEBPACK FOOTER //
// ./src/redux/reducers/ui/index.js